import PocketBase from 'pocketbase';

const baseUrl = import.meta.env.VITE_POCKETBASE_URL || 'http://localhost:8090';

const pb = new PocketBase(baseUrl);

// Enable auto cancellation for duplicate requests
pb.autoCancellation(false);

export default pb;
